/*
创建者 魏强(2018.1.25)
企业品牌 列表
*/
<template>
 <div class="home-module">
	<h3 class="module-title"><span>企业品牌</span></h3>
	<div class="brandList clearfix" id="brandListDiv">
			<div v-for="item in list" class="brandList-item">
				<ul>
					<li v-mouseenter
						v-for="(item2,index) in item.storePinPaiSlideDTOList"
						:class="{active:index==0}"
						:key="index"
						:style="{backgroundImage:`url(${item2.img})`}">
						<router-link :to="item2.slidePinPaiUrl">
						</router-link>
					</li>
				</ul>
				<div class="brandList-info">
					<div class="store-name">
						<router-link :to="{path:'/shop',query:{tab:1,store_id:item.storeId}}">
							{{item.storeName}}
						</router-link>
					</div>
                    <div class="store-slogon">
                    	{{ !!item.shopsigns ? item.shopsigns: "品质生活从这里开始"}}
                    </div>
                    <div class="store-rate">好评率：{{item.praiseRate*100}}%</div>
				</div>
			</div>
	</div>
</div>
</template>
<script>
import {pinpainewPage} from 'api/home';
import {parseAdvList} from 'utils/tool';
export default {
	props:["data"],
	data(){
		let arr = this.data;
	    let list =  arr.map((item)=>{
			let temp = item ;
			temp.storePinPaiSildes = parseAdvList(temp.storePinPaiSildes,'silde_pinpai_url');
			return temp;
	    });
	    return {
			list:list,
			pageNo:2,
			pageSize:6,
			type:2,
			hasMore:true,
			loading:false,
			hasBoundScroll:false
	    }
	},
	directives:{
		mouseenter:{
			inserted:function(el){
				$(el).bind("mouseenter",function(){
					$(this).siblings().removeClass('active');
					$(this).siblings().animate({width:"123px"});
					$(this).animate({width:"650px"});
				});
			}
		}
	},
	mounted(){
		this.bindScroll();
	},
	destroyed(){
		$(window).unbind("scroll");
	},
	activated(){
		this.bindScroll();
	},
	deactivated(){
		$(window).unbind("scroll");
		this.hasBoundScroll = false;
	},
	methods:{
		fetchData(){
			if(this.hasMore&& !this.loading){
				this.loading = true;
				pinpainewPage(this.pageNo,this.pageSize,this.type).then(json=>{
					if(json.resCode==1){
						this.loading = false;
						if(json.resCode==1){
							let data = json.data;
							this.hasMore = data.hasMore;
							if(this.hasMore){
								this.pageNo=this.pageNo+1;
							}
							let storeList = data.list;
							storeList =  storeList.map((store)=>{//storePinPaiSildes
								let temp = store ;
								temp.storePinPaiSlideDTOList = parseAdvList(temp.storePinPaiSlideDTOList);
								return temp;
						    });
							let temp = this.list;
							this.list = temp.concat(storeList);
						}
					}
				});
			}
		},
		bindScroll(){
			let _this = this;
			if(!this.hasBoundScroll){
				$(window).scroll(function(e){
				　　var scrollTop = $(this).scrollTop();
				　　var scrollHeight = $(document).height();
				　　var windowHeight = $(window).height();
				　　if(scrollTop + windowHeight+430 >= scrollHeight && _this.hasMore && !_this.loading ){
						_this.fetchData();
				　　}
				});
			}
		}
	}
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// store-list.vue?76c2eb6f